var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionBlack = function SvgQuestionBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.8 10.25a.69.69 0 0 0-.656.417.6.6 0 0 0-.044.273.65.65 0 0 0 .195.5.73.73 0 0 0 1 0 .66.66 0 0 0 .195-.5.645.645 0 0 0-.423-.645.7.7 0 0 0-.267-.045M9.375 5.19a2 2 0 0 0-1.355-.45 2.8 2.8 0 0 0-1.095.215 2 2 0 0 0-.81.59l.265.93.06-.07a2.3 2.3 0 0 1 .69-.54 1.66 1.66 0 0 1 .76-.19 1 1 0 0 1 .67.2.65.65 0 0 1 .24.54.8.8 0 0 1-.105.405 1.7 1.7 0 0 1-.27.35l-.355.345q-.194.19-.36.405-.178.229-.285.5a1.9 1.9 0 0 0-.115.68q0 .142.03.28v.04h.965v-.17a1.2 1.2 0 0 1 .115-.53q.113-.238.29-.435.18-.206.385-.39.213-.186.405-.395a2.2 2.2 0 0 0 .305-.5c.084-.201.124-.417.12-.635a1.5 1.5 0 0 0-.55-1.175"
  })));
};
export default SvgQuestionBlack;